<template lang="pug">
  v-select.atigroup-select(:value="selectedOption" @input="onInput" :options="options" label="name" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading || disabled")
</template>

<script>
import vSelect from 'vue-select'
import Core from '@/service/apis/Core'

export default {
  props: {
    value: {
      type: Number,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    loading: false,
    selectedOption: null,
    placeholder: 'Select A Validation Response Group',
    options: []
  }),
  created() {
    this.loading = true
    Core.listAtiGroups({ max: 1000 })
      .then((resp) => {
        this.options = resp.data.atiGroup
        this.updateSelectedOption()
      })
      .catch((e) => { this.placeholder = e.response.data.message })
      .then(this.loading = false)
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedAtiGroup() {
      return this.selectedOption
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/AtiGroupSelect.vue